import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../store/directusService';
import {
    loadParticipantByPtCode,
    loadParticipantsSimpleSearch,
    loadRecentParticipants
} from '../../store/participantService';
import { requestGuardedAction } from '../../utils/leaveGuardRegistry';

import SearchOnEnter from './SearchOnEnter';

import classes from './searchStyles/quickSearch.module.css';

const QuickSearchParticipant = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [term, setTerm] = useState('');
    const [active, setActive] = useState(false);
    const [ptCode, setPtCode] = useState('');
    const [recent, setRecent] = useState(false);
    const [isPTRequestSent, setIsPTRequestSent] = useState(false);

    // STORE STATE
    const recentParticipants = useSelector(
        (state) => state.entities.participantService.recentParticipants
    );
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );

    // USEEFFECTS
    useEffect(() => {
        dispatch(loadRecentParticipants());
    }, []);

    useEffect(() => {
        if (
            isPTRequestSent &&
            recent &&
            Object.keys(currentParticipant)?.length > 0 &&
            currentParticipant.ptCode === ptCode
        ) {
            setRecent(false);
            if (!(currentParticipant.contractId in contractDetailsById))
                dispatch(loadContractDetailsForContractId(currentParticipant.contractId));

            if (!(currentParticipant.contractId in servicesByContractId))
                dispatch(loadServiceDetailsForContractId(currentParticipant.contractId));
        }
    }, [isPTRequestSent, currentParticipant]);

    useEffect(() => {
        if (
            isPTRequestSent &&
            currentParticipant.ptCode === ptCode &&
            contractDetailsById[currentParticipant.contractId] &&
            servicesByContractId[currentParticipant.contractId]
        ) {
            navigate('/edit_participant');
            setActive(false);
            setIsPTRequestSent(false);
        }
    }, [isPTRequestSent, contractDetailsById, servicesByContractId, currentParticipant]);

    useEffect(() => {
        if (active) document.addEventListener('click', onClose);

        return () => document.removeEventListener('click', onClose);
    }, [active]);

    const onClose = (e) => {
        const searchEl = document.getElementById('ptQuickSearch');
        if (e && typeof e.composedPath === 'function' && !e.composedPath().includes(searchEl)) {
            setActive(false);
        }
    };

    const onTermChange = (value) => {
        if (value !== '') {
            active && setActive(false);
        }
        setTerm(value);
    };

    const onSearch = () => {
        if (term.trim().length < 3) return;
        dispatch(loadParticipantsSimpleSearch(term));
        location.pathname !== '/participant_search_results' &&
            navigate('/participant_search_results');
    };

    const onSearchBarClick = () => {
        setActive(term === '');
    };

    const onClickRecentPT = (ptCode) => {
        requestGuardedAction(() => {
            setPtCode(ptCode);
            dispatch(loadParticipantByPtCode(ptCode));
            setRecent(true);
            setIsPTRequestSent(true);
        });
    };

    return (
        <div className={classes.headerSearch} onClick={onSearchBarClick} id="ptQuickSearch">
            <ul className={`${classes.recentList} ${active ? classes.showRecentList : ''}`}>
                {recentParticipants.map((el) => (
                    <li key={el.ptCode} onClick={() => onClickRecentPT(el.ptCode)}>
                        <span className={classes.firstCol}>{el.ptCode}</span>
                        <span>
                            {el.firstName} {el.lastName}
                        </span>
                    </li>
                ))}
            </ul>

            <div className={classes.searchbar}>
                <SearchOnEnter
                    searchTerm={term}
                    placeholder="Search participants..."
                    autocomplete="off"
                    search={onSearch}
                    onChange={onTermChange}
                />
            </div>
        </div>
    );
};
export default QuickSearchParticipant;
